var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('AnimatedIcon',{attrs:{"size":_vm.size}},[_c('circle',{staticClass:"animated-circle success-circle",attrs:{"cx":"0","cy":"0","r":"50"}}),_c('path',{staticClass:"animated-path success-check",attrs:{"d":"M -27 2 L -7 21 23 -20"}})])}
var staticRenderFns = []

export { render, staticRenderFns }